(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];
  const IS_PREVIEW = !!document.querySelector(".preview-page");
  const I18N = window.DM_I18N || {};
  const tr = (key, vars = {}) => {
    let s = I18N[key] || "";
    Object.entries(vars).forEach(([k, v]) => {
      s = s.replaceAll(`{${k}}`, v).replaceAll(`{{ ${k} }}`, v);
    });
    return s;
  };
  const moneyLocale = I18N.lang === "en" ? "en-GB" : "it-IT";

  const header = qs(".dm-header");
  const drawer = qs("[data-cart-drawer]");
  const backdrop = qs("[data-drawer-backdrop]");
  const sizeModal = qs("[data-size-modal]");
  const searchPanel = qs("[data-search-panel]");
  const mobileNav = qs("[data-mobile-nav]");
  const cartLines = qs("[data-cart-lines]");
  const countEl = qs("[data-cart-count]");

  const FREE_SHIP = 99;
  const RV_KEY = "dm_recently_viewed";
  let cartCount = 0;
  const cartItems = [];

  const closeMega = () => {
    qsa("[data-mega]").forEach((m) => m.classList.remove("is-open"));
    qsa("[data-mega-item]").forEach((i) => i.classList.remove("is-active"));
  };
  const closeMobile = () => {
    mobileNav?.classList.remove("is-open");
    if (!drawer?.classList.contains("is-open")) document.body.style.overflow = "";
  };
  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.classList.remove("is-open");
    searchPanel.hidden = true;
  };
  const closeFilterDrawer = () => qs("[data-filter-drawer]")?.classList.remove("is-open");
  const openCart = () => {
    drawer?.classList.add("is-open");
    backdrop?.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };
  const closeCart = () => {
    drawer?.classList.remove("is-open");
    backdrop?.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  /* ---------- Cart ---------- */
  const cartTotal = () => cartItems.reduce((acc, i) => acc + Number(i.price) * (i.qty || 1), 0);

  const renderCart = () => {
    cartCount = cartItems.reduce((acc, i) => acc + (i.qty || 1), 0);
    if (cartLines) {
      cartLines.innerHTML = cartItems.length
        ? cartItems
            .map(
              (item, idx) => `<div class="dm-cart-line">
                <img src="${item.img}" alt="">
                <div class="dm-cart-line__body">
                  <div class="dm-cart-line__row">
                    <div>${item.title}</div>
                    <button type="button" class="dm-cart-line__remove" data-cart-remove="${idx}" aria-label="${tr("remove")} ${item.title}">✕</button>
                  </div>
                  <div class="dm-cart-line__row">
                    <div class="dm-qty">
                      <button type="button" data-cart-qty="${idx}:-1" aria-label="${tr("qtyMinus")}">−</button>
                      <span>${item.qty || 1}</span>
                      <button type="button" data-cart-qty="${idx}:1" aria-label="${tr("qtyPlus")}">+</button>
                    </div>
                    <div class="muted">€ ${Number(item.price) * (item.qty || 1)}</div>
                  </div>
                </div>
              </div>`
            )
            .join("")
        : `<p class="muted" data-cart-empty>${tr("cartEmpty") || "Il carrello è vuoto."}</p>`;
    }
    if (countEl) countEl.textContent = String(cartCount);
    qsa("[data-open-cart]").forEach((btn) => {
      btn.setAttribute("aria-label", `${tr("cart") || "Cart"} ${cartCount}`);
    });
    const subtotal = qs("[data-cart-subtotal]");
    if (subtotal) subtotal.textContent = `€ ${cartTotal()}`;
    const fill = qs("[data-ship-fill]");
    const label = qs("[data-ship-label]");
    const total = cartTotal();
    if (fill) fill.style.width = `${Math.min(100, (total / FREE_SHIP) * 100)}%`;
    if (label) {
      label.textContent =
        total >= FREE_SHIP
          ? tr("freeUnlocked")
          : total > 0
          ? tr("freeRemaining", { n: FREE_SHIP - total, amount: `€ ${FREE_SHIP - total}` })
          : tr("freeThreshold");
    }
  };

  const addToCart = (title = "Abito blu notte", price = "490", img = "../assets/product-suit-navy.jpg", open = true) => {
    const existing = cartItems.find((i) => i.title === title);
    if (existing) existing.qty = (existing.qty || 1) + 1;
    else cartItems.push({ title, price, img, qty: 1 });
    renderCart();
    if (open) openCart();
  };

  // Quantity / remove controls inside the drawer
  cartLines?.addEventListener("click", (e) => {
    const rm = e.target.closest("[data-cart-remove]");
    if (rm) {
      cartItems.splice(Number(rm.dataset.cartRemove), 1);
      renderCart();
      renderCheckout();
      return;
    }
    const q = e.target.closest("[data-cart-qty]");
    if (q) {
      const [idx, delta] = q.dataset.cartQty.split(":").map(Number);
      const item = cartItems[idx];
      if (!item) return;
      item.qty = (item.qty || 1) + delta;
      if (item.qty <= 0) cartItems.splice(idx, 1);
      renderCart();
      renderCheckout();
    }
  });

  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-dm-after-login]");
    if (!a) return;
    const dest = a.getAttribute("data-dm-after-login") || "";
    if (!/^(\/[a-z]{2})?\/pages\/[a-z0-9-]+\/?$/.test(dest)) return;
    document.cookie = `dm_after_login=${encodeURIComponent(dest)}; Path=/; Max-Age=1200; SameSite=Lax`;
  });

  const initAddressManager = () => {
    const root = qs("[data-dm-addr]");
    if (!root) return;
    const openForm = (id) => {
      qsa("[data-dm-addr-form]", root).forEach((el) => {
        el.hidden = el.getAttribute("data-dm-addr-form") !== String(id);
      });
      qs(`[data-dm-addr-form="${id}"]`, root)?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    };
    qsa("[data-dm-addr-open]", root).forEach((btn) => {
      btn.addEventListener("click", () => openForm(btn.getAttribute("data-dm-addr-open")));
    });
    qsa("[data-dm-addr-close]", root).forEach((btn) => {
      btn.addEventListener("click", () => {
        const form = btn.closest("[data-dm-addr-form]");
        if (form) form.hidden = true;
      });
    });
    qsa("[data-dm-addr-delete] form", root).forEach((form) => {
      form.addEventListener("submit", (e) => {
        if (!confirm(tr("addrDelete"))) e.preventDefault();
      });
    });
    qsa("[data-dm-addr-country]", root).forEach((sel) => {
      const current = sel.getAttribute("data-current") || "";
      if (!current) return;
      [...sel.options].forEach((opt) => {
        if (opt.value === current || opt.textContent === current) opt.selected = true;
      });
    });
    if (location.hash === "#address-new") openForm("new");
    qsa("[data-dm-company-input]", root).forEach((input) => {
      const nudge = input.parentElement?.querySelector("[data-dm-company-nudge]");
      const sync = () => nudge?.classList.toggle("is-hot", input.value.trim().length >= 2);
      input.addEventListener("input", sync);
      sync();
    });
  };

  const syncB2BUI = () => {
    const b2b = document.body.dataset.customerType === "b2b";
    qsa("[data-checkout-b2c]").forEach((el) => (el.hidden = b2b));
    qsa("[data-checkout-b2b]").forEach((el) => (el.hidden = !b2b));
    qsa("[data-atc-label]").forEach((el) => {
      const isSticky = el.closest("[data-sticky-atc]");
      el.textContent = b2b
        ? isSticky ? tr("quoteShort") : tr("quote")
        : isSticky ? tr("addToCart") : `${tr("addToCart")} — € ${document.body.dataset.dmPrice || "490"}`;
    });
  };

  /* ---------- Router ---------- */
  const escapeHtml = (s) =>
    String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  const recordRecentlyViewed = () => {
    const handle = document.body.dataset.productHandle;
    if (!handle) return;
    try {
      const list = JSON.parse(localStorage.getItem(RV_KEY) || "[]").filter((x) => x.handle !== handle);
      const fallback = qs("[data-recently-viewed]")?.dataset.placeholder || "";
      const priceNum = Number(document.body.dataset.dmPrice || 0);
      list.unshift({
        handle,
        img: document.body.dataset.productImage || fallback,
        title: document.body.dataset.productTitle || "",
        url: IS_PREVIEW ? "#product" : document.body.dataset.productUrl || `/products/${handle}`,
        price: priceNum > 0 ? document.body.dataset.productPriceLabel || "" : "",
        material: document.body.dataset.productMaterial || "",
      });
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (_) {}
  };

  const renderRecentlyViewed = () => {
    const rvMount = qs("[data-recently-viewed]");
    if (!rvMount) return;
    try {
      const current = document.body.dataset.productHandle;
      const fallback = rvMount.dataset.placeholder || "";
      const root = (rvMount.dataset.productsRoot || "/").replace(/\/?$/, "/");
      const list = JSON.parse(localStorage.getItem(RV_KEY) || "[]").filter((p) => p.handle && p.handle !== current);
      const rvGrid = rvMount.querySelector("[data-rv-grid]");
      if (!list.length || !rvGrid) {
        rvMount.hidden = true;
        return;
      }
      rvMount.hidden = false;
      rvGrid.innerHTML = list
        .slice(0, 4)
        .map((p) => {
          const href = IS_PREVIEW ? "#product" : p.handle ? `${root}products/${p.handle}` : p.url || "#";
          const title = escapeHtml(p.title);
          const img = p.img || fallback;
          const go = IS_PREVIEW ? " data-go" : "";
          const micro = p.material ? `<div class="dm-product-card__micro">${escapeHtml(p.material)}</div>` : "";
          const price = p.price ? `<div class="dm-product-card__price">${escapeHtml(p.price)}</div>` : "";
          return `<article class="dm-product-card">
            <div class="dm-product-card__media">
              <a href="${href}"${go}><img class="is-product" src="${img}" alt="${title}" loading="lazy" decoding="async"></a>
            </div>
            <div>
              <a class="dm-product-card__title" href="${href}"${go}>${title}</a>
              ${micro}${price}
            </div>
          </article>`;
        })
        .join("");
    } catch (_) {
      rvMount.hidden = true;
    }
  };

  const showPage = (id) => {
    if (!id) return;
    const pages = qsa(".preview-page");
    if (!pages.length) return;
    pages.forEach((p) => p.classList.toggle("is-active", p.id === id));
    closeMega();
    closeMobile();
    closeSearch();
    closeCart();
    closeFilterDrawer();
    sizeModal?.classList.remove("is-open");
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (id === "product") {
      // Defaults only for direct visits; hydratePdp overrides these on card clicks
      if (!document.body.dataset.productHandle) {
        document.body.dataset.productHandle = "abito-blu-notte";
        document.body.dataset.productTitle = "Abito blu notte";
        document.body.dataset.productImage = "../assets/product-suit-navy.jpg";
        document.body.dataset.dmPrice = "490";
      }
      recordRecentlyViewed();
    }
    if (id === "collection") renderRecentlyViewed();
    if (id === "checkout") {
      const form = qs("[data-checkout-form]");
      const success = qs("[data-checkout-success]");
      if (form) form.hidden = false;
      if (success) success.hidden = true;
      renderCheckout();
    }
    const sticky = qs("[data-sticky-atc]");
    if (sticky && !qs("#product")?.classList.contains("is-active")) {
      sticky.classList.remove("is-visible");
    }
  };
  window.dmShowPage = showPage;

  /* Preview routing: honour the hash on load so shared links land on the right page,
     and keep the browser back/forward buttons working. In-page anchors are ignored. */
  const routeFromHash = () => {
    const id = location.hash.slice(1);
    const el = id && document.getElementById(id);
    if (el && el.classList.contains("preview-page") && !el.classList.contains("is-active")) showPage(id);
  };
  if (qs(".preview-page")) {
    window.addEventListener("hashchange", routeFromHash);
    window.addEventListener("popstate", routeFromHash);
    routeFromHash();
  }

  document.addEventListener("click", (e) => {
    const go = e.target.closest("[data-go]");
    if (!go) return;
    const href = go.getAttribute("href") || "";
    if (!href.startsWith("#") || href === "#") return;
    const id = href.slice(1);
    if (!document.getElementById(id)) return;
    if (document.querySelector(".preview-page")) {
      e.preventDefault();
      if (id === "product") {
        // Prefer the canonical catalog card (has full data attributes) matched by title,
        // so search hits, related products and recently viewed all hydrate correctly.
        const local = go.closest(".dm-product-card");
        const t = (
          go.dataset.hitTitle ||
          go.querySelector(".dm-search-hit__title")?.textContent ||
          local?.querySelector(".dm-product-card__title")?.textContent ||
          ""
        ).trim();
        let card = t
          ? qsa("[data-product-grid] .dm-product-card").find(
              (c) => c.querySelector(".dm-product-card__title")?.textContent.trim() === t
            )
          : null;
        card = card || local;
        if (card) hydratePdp(card);
      }
      showPage(id);
      if (location.hash.slice(1) !== id) history.pushState(null, "", "#" + id);
      const scrollTarget = go.getAttribute("data-scroll-to");
      if (scrollTarget) {
        requestAnimationFrame(() => {
          document.querySelector(scrollTarget)?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
    }
  });

  document.addEventListener("click", (e) => {
    const sc = e.target.closest("[data-scroll]");
    if (!sc) return;
    const href = sc.getAttribute("href") || "";
    if (!href.startsWith("#")) return;
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  const accountMenu = qs("[data-account-menu]");
  if (accountMenu) {
    const trigger = qs("[data-account-trigger]", accountMenu);
    const setExpanded = (open) => {
      accountMenu.classList.toggle("is-open", open);
      trigger?.setAttribute("aria-expanded", open ? "true" : "false");
    };
    if (window.matchMedia("(hover: none)").matches) {
      trigger?.addEventListener("click", (e) => {
        e.preventDefault();
        setExpanded(!accountMenu.classList.contains("is-open"));
      });
    }
    document.addEventListener("click", (e) => {
      if (!accountMenu.contains(e.target)) setExpanded(false);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setExpanded(false);
    });
  }

  /* ---------- Mega menu ---------- */
  let megaCloseTimer;
  const cancelMegaClose = () => clearTimeout(megaCloseTimer);
  const scheduleMegaClose = () => {
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(closeMega, 700);
  };
  qsa("[data-mega-item]").forEach((item) => {
    const open = () => {
      cancelMegaClose();
      qsa("[data-mega]").forEach((m) => m.classList.remove("is-open"));
      qsa("[data-mega-item]").forEach((i) => i.classList.remove("is-active"));
      item.classList.add("is-active");
      const megaId = item.getAttribute("data-mega-target");
      if (megaId) qs(`#${megaId}`)?.classList.add("is-open");
    };
    item.addEventListener("mouseenter", open);
    item.addEventListener("focus", open);
    item.addEventListener("click", (e) => {
      const nav = item.getAttribute("data-nav");
      open();
      if (!nav) return;
      if (nav.startsWith("#") && document.querySelector(".preview-page")) {
        e.preventDefault();
        showPage(nav.slice(1));
      } else if (!nav.startsWith("#")) {
        e.preventDefault();
        window.location.href = nav;
      }
    });
  });
  const dmTop = qs(".dm-top");
  dmTop?.addEventListener("mouseenter", cancelMegaClose);
  dmTop?.addEventListener("mouseleave", scheduleMegaClose);
  qsa("[data-mobile-toggle]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = !mobileNav?.classList.contains("is-open");
      mobileNav?.classList.toggle("is-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    });
  });
  mobileNav?.addEventListener("click", (e) => {
    if (e.target === mobileNav) closeMobile();
  });

  /* ---------- Footer accordion ---------- */
  qsa("[data-footer-acc]").forEach((acc) => {
    acc.querySelector("button")?.addEventListener("click", () => {
      const open = !acc.classList.contains("is-open");
      qsa("[data-footer-acc]").forEach((a) => a.classList.remove("is-open"));
      if (open) acc.classList.add("is-open");
    });
  });

  /* ---------- Cart open/close ---------- */
  qsa("[data-open-cart]").forEach((el) =>
    el.addEventListener("click", (e) => {
      e.preventDefault();
      openCart();
    })
  );
  qsa("[data-close-cart]").forEach((el) => el.addEventListener("click", closeCart));
  backdrop?.addEventListener("click", closeCart);

  const shopifyAddToCart = async (variantId, quantity = 1) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || tr("cartError"));
    }
    return res.json();
  };

  const refreshShopifyCart = async () => {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) return null;
    const cart = await res.json();
    if (countEl) countEl.textContent = String(cart.item_count);
    qsa("[data-open-cart]").forEach((btn) => {
      btn.setAttribute("aria-label", `${tr("cart") || "Cart"} ${cart.item_count}`);
    });
    const body = qs("[data-cart-drawer-body]");
    const subtotal = qs("[data-cart-subtotal] strong");
    if (subtotal) {
      subtotal.textContent = new Intl.NumberFormat(moneyLocale, {
        style: "currency",
        currency: cart.currency || "EUR",
      }).format(cart.total_price / 100);
    }
    if (body) {
      body.innerHTML = cart.item_count
        ? cart.items
            .map(
              (item, idx) => {
                const line = idx + 1;
                return `<div class="dm-cart-line">
                ${item.image ? `<img decoding="async" loading="lazy" src="${item.image}" alt="${item.product_title}">` : ""}
                <div class="dm-cart-line__body">
                  <div class="dm-cart-line__row">
                    <div>
                      <div>${item.product_title}</div>
                      <div class="muted" style="font-size:.85rem;">${item.variant_title || ""}</div>
                    </div>
                    <a class="dm-cart-line__remove" href="/cart/change?line=${line}&quantity=0" aria-label="${tr("remove")}">✕</a>
                  </div>
                  <div class="dm-cart-line__row">
                    <div class="dm-qty">
                      <a href="/cart/change?line=${line}&quantity=${Math.max(0, item.quantity - 1)}" aria-label="${tr("qtyMinus")}">−</a>
                      <span>${item.quantity}</span>
                      <a href="/cart/change?line=${line}&quantity=${item.quantity + 1}" aria-label="${tr("qtyPlus")}">+</a>
                    </div>
                    <div>${new Intl.NumberFormat(moneyLocale, { style: "currency", currency: cart.currency || "EUR" }).format(item.final_line_price / 100)}</div>
                  </div>
                </div>
              </div>`;
              }
            )
            .join("")
        : `<p class="muted">${tr("cartEmpty")}</p>`;
    }
    return cart;
  };

  let productGallery = null;
  try {
    const galleryNode = qs("[data-product-gallery]");
    if (galleryNode) productGallery = JSON.parse(galleryNode.textContent);
  } catch (_) {
    productGallery = null;
  }

  const galleryFile = (img) =>
    String(img?.src || "")
      .split("/")
      .pop()
      .split("?")[0]
      .toLowerCase();

  const imageFamily = (src) =>
    galleryFile({ src })
      .replace(/\.[a-z0-9]+$/i, "")
      .replace(/-lq$/i, "")
      .replace(/-\d+$/i, "");

  const isEditorialSrc = (src) => /giovanni|mocchetti/i.test(String(src || ""));

  const imagesForColor = (color) => {
    const images = productGallery?.images || [];
    if (!color || !productGallery?.colorVariants?.[color]) return images;
    const ids = new Set((productGallery.colorVariants[color] || []).map(String));
    const thisWorn = productGallery.colorWorn?.[color];
    const otherWorn = new Set(
      Object.entries(productGallery.colorWorn || {})
        .filter(([c, w]) => c !== color && w?.src)
        .map(([, w]) => galleryFile(w))
    );
    const assigned = images.find(
      (img) => (img.variantIds || []).some((id) => ids.has(String(id))) && !isEditorialSrc(img.src)
    );
    const family = assigned ? imageFamily(assigned.src) : "";
    const out = images.filter((img) => {
      const vids = (img.variantIds || []).map(String);
      if (vids.some((id) => ids.has(id))) return true;
      if (vids.length) return false;
      if (isEditorialSrc(img.src)) {
        if (!thisWorn?.src) return false;
        const file = galleryFile(img);
        if (otherWorn.has(file)) return false;
        return true;
      }
      return family && imageFamily(img.src) === family;
    });
    if (thisWorn?.src && !out.some((img) => galleryFile(img) === galleryFile(thisWorn))) {
      out.push(thisWorn);
    }
    const pack = out.filter((img) => !isEditorialSrc(img.src));
    const wornShots = out.filter((img) => isEditorialSrc(img.src));
    return pack.length ? [pack[0], ...wornShots, ...pack.slice(1)] : wornShots;
  };

  const renderColorGallery = (color) => {
    const thumbsWrap = qs(".dm-pdp__thumbs");
    const mainImg = qs("[data-gallery-main]");
    if (!thumbsWrap || !productGallery) return;
    const images = imagesForColor(color);
    if (!images.length) return;
    thumbsWrap.innerHTML = images
      .map(
        (img, i) =>
          `<button type="button" class="${i === 0 ? "is-active" : ""}" data-gallery-thumb data-src="${img.src}">
            <img decoding="async" loading="lazy" src="${img.thumb}" alt="">
          </button>`
      )
      .join("");
    if (mainImg) {
      mainImg.src = images[0].src;
      if (images[0].alt) mainImg.alt = images[0].alt;
    }
    document.body.dataset.productImage = images[0].src;
  };

  const initShopifyProductForm = () => {
    const form = qs('form[action*="/cart/add"]');
    const variantNode = qs("[data-product-variants]");
    if (!form || !variantNode) return;
    let variants = [];
    try {
      variants = JSON.parse(variantNode.textContent);
    } catch (_) {
      return;
    }
    const stockNode = qs("[data-variant-stock]");
    if (stockNode) {
      try {
        const stockRows = JSON.parse(stockNode.textContent);
        const byId = new Map(stockRows.map((row) => [String(row.id), row]));
        variants.forEach((variant) => {
          const row = byId.get(String(variant.id));
          if (!row) return;
          variant.inventory_quantity = row.qty;
          if (row.tracked) variant.inventory_management = variant.inventory_management || "shopify";
        });
      } catch (_) {
        /* keep parsed variants */
      }
    }
    const idInput = form.querySelector('[name="id"]');
    const priceEls = qsa("[data-product-price]").filter((el) => el !== document.body);
    const mainAtc = qs("[data-main-atc]");
    const requestedId = new URLSearchParams(location.search).get("variant") || idInput?.value;

    const selectedOptions = () => {
      const color = qs("[data-color-thumbs] .is-selected")?.dataset.color;
      const size = qs("[data-size-avail] .is-selected")?.dataset.size;
      return { color, size };
    };

    const pickVariant = () => {
      const { color, size } = selectedOptions();
      const match = variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3].filter(Boolean);
        const colorOk = !color || opts.includes(color);
        const sizeOk = !size || opts.includes(size);
        return colorOk && sizeOk;
      });
      return match || variants.find((v) => v.available) || variants[0];
    };

    const syncUiToVariant = (variant) => {
      if (!variant) return;
      const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      const thumb = qsa(".dm-color-thumb").find((t) => opts.includes(t.dataset.color));
      if (thumb) {
        qsa(".dm-color-thumb").forEach((b) => b.classList.remove("is-selected"));
        thumb.classList.add("is-selected");
        const nameEl = qs("[data-color-name]");
        if (nameEl && thumb.dataset.color) nameEl.textContent = thumb.dataset.color;
        renderColorGallery(thumb.dataset.color);
      }
      const sizeBtn = qsa("[data-size-avail] button").find((t) => opts.includes(t.dataset.size));
      if (sizeBtn) {
        qsa("[data-size-avail] button").forEach((b) => b.classList.remove("is-selected"));
        sizeBtn.classList.add("is-selected");
      }
    };

    const variantQty = (variant) => {
      const raw = variant?.inventory_quantity;
      return Number.isFinite(Number(raw)) ? Number(raw) : 0;
    };
    const variantTracked = (variant) => Boolean(variant?.inventory_management);
    const stockStateFor = (variant) => {
      if (!variant) return "out";
      if (variantTracked(variant)) {
        const qty = variantQty(variant);
        if (qty < 1) return "out";
        if (qty <= 2) return "low";
        return "ok";
      }
      return variant.available ? "ok" : "out";
    };
    const stockCopy = (state) => {
      if (state === "out") return tr("notifyMe") || "Avvisami";
      if (state === "low") return tr("lowStock") || "Ultimi pezzi";
      return tr("available") || "Disponibile";
    };
    const syncSizeStock = (color) => {
      const wrap = qs("[data-size-avail]");
      if (!wrap) return;
      qsa("button", wrap).forEach((btn) => {
        const size = btn.dataset.size;
        const match = variants.find((v) => {
          const opts = [v.option1, v.option2, v.option3].filter(Boolean);
          const colorOk = !color || opts.includes(color);
          const sizeOk = !size || opts.includes(size);
          return colorOk && sizeOk;
        });
        const state = stockStateFor(match);
        btn.dataset.stock = state;
        btn.classList.toggle("is-low", state === "low");
        btn.classList.toggle("is-soldout", state === "out");
        btn.classList.toggle("is-notify", state === "out");
        btn.disabled = state === "out";
        const small = btn.querySelector("small");
        if (small) small.textContent = stockCopy(state);
      });
      let selected = qs("[data-size-avail] .is-selected");
      if (selected?.dataset.stock === "out") {
        selected.classList.remove("is-selected");
        selected = qs("[data-size-avail] button:not([disabled])");
        selected?.classList.add("is-selected");
      }
      if (selected) updateSizeStatus(selected);
    };

    const applyVariant = (preferId) => {
      const variant =
        (preferId && variants.find((v) => String(v.id) === String(preferId))) || pickVariant();
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      syncSizeStock(selectedOptions().color);
      const formatted = new Intl.NumberFormat(moneyLocale, {
        style: "currency",
        currency: document.body.dataset.shopCurrency || "EUR",
      }).format(variant.price / 100);
      priceEls.forEach((el) => {
        el.textContent = formatted;
      });
      if (mainAtc && mainAtc.tagName === "BUTTON" && !mainAtc.classList.contains("btn--quote")) {
        const label = mainAtc.dataset.atcBase || tr("addToCart");
        mainAtc.textContent = `${label} — ${new Intl.NumberFormat(moneyLocale, {
          style: "currency",
          currency: document.body.dataset.shopCurrency || "EUR",
        }).format(variant.price / 100)}`;
      }
      document.body.dataset.dmPrice = String(variant.price / 100);
    };

    qs("[data-color-thumbs]")?.addEventListener("click", () =>
      setTimeout(() => {
        applyVariant();
        syncSizeStock(selectedOptions().color);
      }, 0)
    );
    qs("[data-size-avail]")?.addEventListener("click", () => setTimeout(applyVariant, 0));
    if (requestedId) {
      syncUiToVariant(variants.find((v) => String(v.id) === String(requestedId)));
    }
    applyVariant(requestedId);

    const submitAdd = async (btn) => {
      if (!idInput?.value) return;
      if (btn) {
        btn.disabled = true;
        btn.dataset.loading = "1";
      }
      try {
        await shopifyAddToCart(idInput.value, 1);
        await refreshShopifyCart();
        openCart();
        showToast(tr("added"));
      } catch (err) {
        showToast(err.message || tr("cartError"));
      } finally {
        if (btn) {
          btn.disabled = false;
          delete btn.dataset.loading;
          applyVariant();
        }
      }
    };

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      submitAdd(mainAtc);
    });

    qs("[data-sticky-atc] [data-shopify-atc]")?.addEventListener("click", (e) => {
      e.preventDefault();
      submitAdd(e.currentTarget);
    });
  };

  qsa("[data-add-to-cart]").forEach((btn) =>
    btn.addEventListener("click", (e) => {
      if (!IS_PREVIEW) return;
      e.preventDefault();
      addToCart(
        btn.dataset.cartTitle || document.body.dataset.productTitle || "Abito blu notte",
        btn.dataset.cartPrice || document.body.dataset.dmPrice || "490",
        btn.dataset.cartImg || document.body.dataset.productImage || "../assets/product-suit-navy.jpg"
      );
    })
  );

  qs("[data-buy-now]")?.addEventListener("click", () => {
    addToCart(
      document.body.dataset.productTitle,
      document.body.dataset.dmPrice,
      document.body.dataset.productImage,
      false
    );
    openCart();
  });

  /* ---------- Color thumbs ---------- */
  const colorThumbs = qs("[data-color-thumbs]");
  colorThumbs?.addEventListener("click", (e) => {
    const btn = e.target.closest(".dm-color-thumb");
    if (!btn || btn.disabled || btn.classList.contains("is-soldout")) return;
    qsa(".dm-color-thumb", colorThumbs).forEach((b) => b.classList.remove("is-selected"));
    btn.classList.add("is-selected");
    const nameEl = qs("[data-color-name]");
    if (nameEl && btn.dataset.color) nameEl.textContent = btn.dataset.color;
    renderColorGallery(btn.dataset.color);
  });

  /* ---------- Fit select ---------- */
  qs("[data-style-select]")?.addEventListener("click", (e) => {
    const btn = e.target.closest("button");
    if (!btn) return;
    qsa("[data-style-select] button").forEach((b) => b.classList.remove("is-active"));
    btn.classList.add("is-active");
  });

  /* ---------- Size availability ---------- */
  const updateSizeStatus = (btn) => {
    const status = qs("[data-size-status]");
    if (!status || !btn) return;
    const raw = btn.dataset.size;
    const size = raw === "u" ? "unica" : /^[a-z]+$/i.test(raw) ? raw.toUpperCase() : raw;
    const stock = btn.dataset.stock;
    status.classList.remove("is-ok", "is-warn", "is-out");
    if (stock === "out") {
      status.classList.add("is-out");
      status.textContent = tr("sizeOut", { size });
    } else if (stock === "low") {
      status.classList.add("is-warn");
      status.textContent = tr("sizeLow", { size });
    } else {
      status.classList.add("is-ok");
      status.textContent = tr("sizeOk", { size });
    }
  };
  const sizeAvail = qs("[data-size-avail]");
  if (sizeAvail) {
    qsa("button", sizeAvail).forEach((b) => {
      if (b.dataset.stock === "low") b.classList.add("is-low");
      if (b.dataset.stock === "out") b.classList.add("is-soldout");
    });
    sizeAvail.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;
      if (btn.classList.contains("is-soldout")) {
        if (btn.classList.contains("is-notify")) {
          btn.querySelector("small").textContent = tr("notifyDone");
          const status = qs("[data-size-status]");
          if (status) {
            status.className = "dm-size-status is-ok";
            const sizeLabel = /^[a-z]+$/i.test(btn.dataset.size) ? btn.dataset.size.toUpperCase() : btn.dataset.size;
            status.textContent = tr("notifyOk", { size: sizeLabel });
          }
        }
        return;
      }
      qsa("button", sizeAvail).forEach((b) => b.classList.remove("is-selected"));
      btn.classList.add("is-selected");
      updateSizeStatus(btn);
    });
  }

  /* ---------- Complete the look ---------- */
  const updateCtlTotal = () => {
    const selected = qsa("[data-ctl-item].is-selected");
    const totalEl = qs("[data-ctl-total]");
    if (!totalEl) return;
    if (!selected.length) {
      totalEl.textContent = tr("noneSelected");
      return;
    }
    const sum = selected.reduce((acc, el) => acc + Number(el.dataset.price || 0), 0);
    totalEl.textContent = tr("ctlCount", { count: selected.length, sum });
  };
  qsa("[data-ctl-item]").forEach((card) => {
    card.addEventListener("click", () => {
      card.classList.toggle("is-selected");
      updateCtlTotal();
    });
  });
  qs("[data-ctl-add]")?.addEventListener("click", async () => {
    const selected = qsa("[data-ctl-item].is-selected");
    if (!selected.length) return;
    const ids = selected.map((el) => el.dataset.variantId).filter(Boolean);
    if (ids.length) {
      try {
        for (const id of ids) await shopifyAddToCart(id, 1);
        await refreshShopifyCart();
        openCart();
      } catch (err) {
        showToast(err.message || tr("cartError"));
      }
      return;
    }
    selected.forEach((el) => addToCart(el.dataset.title, el.dataset.price, el.querySelector("img")?.src, false));
    openCart();
  });

  /* ---------- Size modal ---------- */
  qsa("[data-open-size-guide]").forEach((el) =>
    el.addEventListener("click", (e) => {
      e.preventDefault();
      sizeModal?.classList.add("is-open");
    })
  );
  qsa("[data-close-size-guide]").forEach((el) =>
    el.addEventListener("click", () => sizeModal?.classList.remove("is-open"))
  );

  /* ---------- Sticky ATC ---------- */
  const sticky = qs("[data-sticky-atc]");
  const mainAtc = qs("[data-main-atc]");
  if (sticky && mainAtc && "IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => {
      const onProduct =
        document.body.classList.contains("template-product") ||
        qs("#product")?.classList.contains("is-active");
      sticky.classList.toggle("is-visible", onProduct && !entry.isIntersecting);
    }).observe(mainAtc);
  }

  /* ---------- PLP view toggle ---------- */
  qsa("[data-view-toggle]").forEach((wrap) => {
    wrap.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const card = wrap.closest(".dm-product-card");
      qsa("button", wrap).forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      card?.classList.toggle("is-worn", btn.dataset.view === "worn");
    });
  });

  /* ---------- Toast ---------- */
  let toastTimer;
  const showToast = (msg) => {
    let toast = qs("[data-toast]");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "dm-toast";
      toast.setAttribute("data-toast", "");
      toast.setAttribute("role", "status");
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2400);
  };

  /* ---------- Wishlist ---------- */
  qsa("[data-wishlist]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const added = !btn.classList.contains("is-active");
      btn.classList.toggle("is-active", added);
      btn.setAttribute("aria-pressed", added ? "true" : "false");
      const card = btn.closest(".dm-product-card");
      const title = card?.querySelector(".dm-product-card__title")?.textContent?.trim();
      showToast(added ? `${title ? title + " — " : ""}Aggiunto ai preferiti` : "Rimosso dai preferiti");
    });
  });

  /* ---------- Gallery ---------- */
  const main = qs("[data-gallery-main-wrap]");
  const mainImg = qs("[data-gallery-main]");
  const thumbsWrap = qs(".dm-pdp__thumbs");
  thumbsWrap?.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    qsa("[data-gallery-thumb]", thumbsWrap).forEach((t) => t.classList.remove("is-active"));
    thumb.classList.add("is-active");
    const src = thumb.getAttribute("data-src");
    if (mainImg && src) mainImg.src = src;
    main?.classList.remove("is-zoomed");
  });
  main?.addEventListener("click", () => main.classList.toggle("is-zoomed"));
  main?.addEventListener("mousemove", (e) => {
    if (!main.classList.contains("is-zoomed")) return;
    const r = main.getBoundingClientRect();
    main.style.setProperty("--zoom-x", `${((e.clientX - r.left) / r.width) * 100}%`);
    main.style.setProperty("--zoom-y", `${((e.clientY - r.top) / r.height) * 100}%`);
  });

  /* ---------- Size assistant ---------- */
  qsa("[data-size-assistant]").forEach((assistantForm) => {
    assistantForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const height = Number(qs("[name=height]", assistantForm)?.value || 0);
      const fit = qs("[name=fit]", assistantForm)?.value || "regular";
      // Detect the scale from the sizes currently shown on the PDP
      const sizeBtns = qsa("[data-size-avail] button");
      const firstSize = sizeBtns[0]?.dataset.size || "46";
      const isLetters = /^(xs|s|m|l|xl|xxl)$/i.test(firstSize);
      const isCollar = !isLetters && Number(firstSize) < 45;
      let size, label;
      if (isLetters) {
        const scale = ["s", "m", "l", "xl"];
        let idx = height < 172 ? 0 : height < 184 ? 1 : height < 192 ? 2 : 3;
        if (fit === "slim" && idx > 0) idx -= 1;
        if (fit === "relaxed" && idx < scale.length - 1) idx += 1;
        size = scale[idx];
        label = size.toUpperCase();
      } else if (isCollar) {
        size = height < 172 ? 38 : height < 178 ? 39 : height < 184 ? 40 : height < 190 ? 41 : 42;
        if (fit === "slim" && size > 38) size -= 1;
        if (fit === "relaxed" && size < 43) size += 1;
        label = `${size} (collo)`;
      } else {
        size = height < 172 ? 46 : height < 178 ? 48 : height < 184 ? 50 : height < 190 ? 52 : 54;
        if (fit === "slim" && size > 46) size -= 2;
        if (fit === "relaxed") size += 2;
        label = `${size} IT`;
      }
      const out = qs("[data-assistant-result]", assistantForm.closest(".dm-assistant") || document);
      if (out) out.textContent = tr("yourSize", { label });
      const sizeBtn = sizeBtns.find((b) => b.dataset.size === String(size));
      if (sizeBtn && !sizeBtn.classList.contains("is-soldout")) {
        sizeBtns.forEach((b) => b.classList.remove("is-selected"));
        sizeBtn.classList.add("is-selected");
        updateSizeStatus(sizeBtn);
      }
    });
  });

  /* ---------- FILTERS (real) ---------- */
  const grid = qs("[data-product-grid]");
  const cards = grid ? qsa(".dm-product-card", grid) : [];
  const filterState = { modello: [], colore: [], materiale: [], taglia: [], novita: [] };
  const groupLabels = { modello: "Modello", colore: "Colore", materiale: "Materiale", taglia: "Taglia", novita: "Novità" };
  const valueLabels = {
    modello: { completi: "Completi", giacche: "Giacche", camicie: "Camicie", maglieria: "Maglieria", accessori: "Accessori" },
    colore: { blu: "Blu", grigio: "Grigio", verde: "Verde", azzurro: "Azzurro", bianco: "Bianco", beige: "Beige", bordeaux: "Bordeaux", marrone: "Marrone" },
    materiale: { lana: "Lana", cotone: "Cotone", lino: "Lino", cashmere: "Cashmere", seta: "Seta", cuoio: "Cuoio" },
    novita: { "1": "NEW!" },
  };
  const colorSwatches = { blu: "#1c2b3a", grigio: "#6b6f73", verde: "#0b3d2e", azzurro: "#7ea4c4", bianco: "#f4f4f2", beige: "#d8c9a8", bordeaux: "#5e1f24", marrone: "#6b4a2e" };

  const uniqueValues = (group) => {
    const set = new Set();
    cards.forEach((c) => {
      const raw = c.dataset[`f${group.charAt(0).toUpperCase() + group.slice(1)}`] || "";
      raw.split(",").forEach((v) => v && set.add(v));
    });
    return [...set];
  };
  const countFor = (group, value) =>
    cards.filter((c) => (c.dataset[`f${group.charAt(0).toUpperCase() + group.slice(1)}`] || "").split(",").includes(value)).length;

  const buildPanel = (group, container) => {
    container.innerHTML = uniqueValues(group)
      .map((value) => {
        const label = valueLabels[group]?.[value] || value.charAt(0).toUpperCase() + value.slice(1);
        const swatch = colorSwatches[value] ? `<span class="dm-swatch" style="background:${colorSwatches[value]}"></span>` : "";
        return `<button type="button" class="dm-filter-opt" data-filter-opt data-group="${group}" data-value="${value}">
          <span class="dm-filter-opt__box">✓</span>${swatch}<span>${label}</span>
          <span class="dm-filter-opt__count">${countFor(group, value)}</span>
        </button>`;
      })
      .join("");
  };

  const matches = (card) =>
    Object.entries(filterState).every(([group, selected]) => {
      if (!selected.length) return true;
      const key = `f${group.charAt(0).toUpperCase() + group.slice(1)}`;
      const values = (card.dataset[key] || "").split(",");
      return selected.some((s) => values.includes(s));
    });

  const applyFilters = () => {
    let visible = 0;
    cards.forEach((card) => {
      const show = matches(card);
      card.style.display = show ? "" : "none";
      if (show) visible += 1;
    });
    const count = qs("[data-result-count]");
    if (count) count.textContent = `${visible} prodott${visible === 1 ? "o" : "i"}`;
    const applyLabel = qs("[data-apply-label]");
    if (applyLabel) applyLabel.textContent = `Vedi ${visible} prodott${visible === 1 ? "o" : "i"}`;
    const empty = qs("[data-filter-empty]");
    if (empty) empty.hidden = visible !== 0;

    // Reset the collection title when no filter is active anymore
    const anyActive = Object.values(filterState).some((sel) => sel.length);
    if (!anyActive) setCollectionTitle(null);

    // Active chips
    const chipsWrap = qs("[data-active-chips]");
    if (chipsWrap) {
      const chips = [];
      Object.entries(filterState).forEach(([group, selected]) => {
        selected.forEach((value) => {
          const label = valueLabels[group]?.[value] || value.charAt(0).toUpperCase() + value.slice(1);
          chips.push(
            `<button type="button" class="dm-active-chip" data-chip data-group="${group}" data-value="${value}">${label} <span aria-hidden="true">✕</span></button>`
          );
        });
      });
      if (chips.length) chips.push(`<button type="button" class="dm-active-chips__clear" data-clear-filters>Rimuovi tutto</button>`);
      chipsWrap.innerHTML = chips.join("");
    }

    // Group button selection state
    qsa("[data-filter-group-btn]").forEach((btn) => {
      const group = btn.closest("[data-filter-group]")?.dataset.filterGroup;
      const n = filterState[group]?.length || 0;
      btn.classList.toggle("has-selection", n > 0);
      btn.innerHTML = `${groupLabels[group]}${n ? ` (${n})` : ""}`;
    });
    const activeCount = Object.values(filterState).reduce((acc, arr) => acc + arr.length, 0);
    const triggerCount = qs("[data-filter-active-count]");
    if (triggerCount) triggerCount.textContent = activeCount ? `(${activeCount})` : "";
  };

  const toggleFilter = (group, value, force) => {
    const arr = filterState[group];
    const idx = arr.indexOf(value);
    const on = force !== undefined ? force : idx === -1;
    if (on && idx === -1) arr.push(value);
    if (!on && idx !== -1) arr.splice(idx, 1);
    // sync all option buttons for this group/value
    qsa(`[data-filter-opt][data-group="${group}"][data-value="${value}"]`).forEach((o) =>
      o.classList.toggle("is-selected", on)
    );
    applyFilters();
  };

  const clearFilters = () => {
    Object.keys(filterState).forEach((g) => (filterState[g] = []));
    qsa("[data-filter-opt]").forEach((o) => o.classList.remove("is-selected"));
    applyFilters();
  };

  /* Dynamic PDP: populate the demo product page from the clicked card */
  const PDP_DEFAULT = {
    title: "Abito blu notte",
    micro: "Completi · Lana Super 120s · Confezionato in Puglia",
    priceHtml: "<s>€ 590</s> € 490",
    img: "../assets/product-suit-navy.jpg",
    taglia: "46,48,50,52,54,56",
    colore: "blu",
    modello: "completi",
  };
  const PDP_THUMB_EXTRAS = ["../assets/worn-suit-navy.jpg", "../assets/fabric-wool-portrait.jpg", "../assets/detail-buttonhole.jpg"];

  /* Fabric macro per material: keeps every gallery third shot truthful to the cloth */
  /* Portrait crops: the gallery frame is 4:5, so the landscape macros used in the
     editorial sections would lose nearly half their width here. */
  /* Colourways carry their own macro so the cloth in the gallery matches the garment
     on screen; a card names one through data-macro. */
  const FABRIC_MACRO = {
    lana: "../assets/fabric-wool-portrait.jpg",
    "lana-grigio": "../assets/fabric-wool-grey-portrait.jpg",
    "lana-verde": "../assets/fabric-wool-green-portrait.jpg",
    "lana-antracite": "../assets/fabric-wool-anthracite-portrait.jpg",
    cashmere: "../assets/fabric-cashmere-portrait.jpg",
    "cashmere-blu": "../assets/fabric-cashmere-navy-portrait.jpg",
    merino: "../assets/fabric-merino-portrait.jpg",
    "merino-grigio": "../assets/fabric-merino-charcoal-portrait.jpg",
    lino: "../assets/fabric-linen-portrait.jpg",
    cotone: "../assets/fabric-cotton-portrait.jpg",
    seta: "../assets/fabric-silk-portrait.jpg",
    cuoio: "../assets/fabric-leather-portrait.jpg",
  };

  /* Per-product module config: mirrors what Shopify product metafields will drive */
  const PDP_CATALOG = {
    "abito-blu-notte": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Regular. Spalla mezza costruita, girovita morbido. Il modello è alto 188 cm e indossa la 50.",
      care: "Lavaggio a secco. Stiratura a temperatura media.",
      bullets: ["Completo due pezzi in lana Super 120s italiana", "Fodera in cupro, bottoni in corozo", "Spalla mezza costruita, giacca due bottoni", "Pantalone con pince leggera", "Confezionato in Puglia"],
      styleNote: "Il blu notte è l’abito che lavora tutto il giorno: credibile in riunione, giusto a cena. Si porta con camicia bianca e cravatta in seta.",
      boxes: {
        tessuto: ["Tessuto", "Super 120s da lanifici italiani: mano fine, piega che tiene tutto il giorno."],
        vestibilita: ["Vestibilità", "Taglio misurato milanese. Né troppo, né poco."],
        madeinitaly: ["Made in Italy", "Filiera corta e certificata, dalla pezza al capo finito."],
      },
      look: { enabled: true, image: "../assets/worn-suit-navy.jpg", caption: "Il look completo: abito blu notte, camicia azzurra, cravatta bordeaux" },
    },
    "abito-grigio-medio": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Regular. Spalla mezza costruita. Il modello è alto 188 cm e indossa la 50.",
      care: "Lavaggio a secco. Stiratura a temperatura media.",
      bullets: ["Completo due pezzi in lana Super 120s", "Grigio medio: il più versatile del guardaroba", "Fodera in cupro, bottoni in corozo", "Pantalone con pince leggera", "Confezionato in Puglia"],
      styleNote: "Il grigio medio va ovunque: ufficio con camicia bianca, sera con dolcevita. Spezzalo: la giacca vive anche con denim scuro.",
      boxes: {
        tessuto: ["Tessuto", "Super 120s da lanifici italiani: mano fine, piega che tiene tutto il giorno."],
        vestibilita: ["Vestibilità", "Taglio misurato milanese. Né troppo, né poco."],
        madeinitaly: ["Made in Italy", "Filiera corta e certificata, dalla pezza al capo finito."],
      },
      look: { enabled: true, image: "../assets/worn-suit-grey.jpg", caption: "Il look completo: abito grigio medio, camicia bianca, cintura in cuoio" },
    },
    "abito-verde-bottiglia": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Regular. Spalla mezza costruita. Il modello è alto 188 cm e indossa la 50.",
      care: "Lavaggio a secco. Stiratura a temperatura media.",
      bullets: ["Completo due pezzi in lana Super 120s", "Verde bottiglia: carattere senza rumore", "Fodera in cupro, bottoni in corozo", "Pantalone con pince leggera", "Confezionato in Puglia"],
      styleNote: "Il verde bottiglia è il nuovo blu: si porta con camicia bianca o azzurra, mai nera. Perfetto dal tramonto in poi.",
      boxes: {
        tessuto: ["Tessuto", "Super 120s da lanifici italiani: mano fine, piega che tiene tutto il giorno."],
        vestibilita: ["Vestibilità", "Taglio misurato milanese. Né troppo, né poco."],
        madeinitaly: ["Made in Italy", "Filiera corta e certificata, dalla pezza al capo finito."],
      },
      look: { enabled: true, image: "../assets/worn-suit-green.jpg", caption: "Il look completo: abito verde bottiglia, camicia bianca, cintura in cuoio" },
    },
    "abito-antracite": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Slim. Silhouette asciutta, spalla pulita. Il modello è alto 188 cm e indossa la 50.",
      care: "Lavaggio a secco. Stiratura a temperatura media.",
      bullets: ["Completo due pezzi in lana Super 130s", "Antracite: il formale contemporaneo", "Fodera in cupro, bottoni in corozo", "Pantalone slim senza pince", "Confezionato in Puglia"],
      styleNote: "L’antracite è il tailleur da città: con camicia bianca è boardroom, con maglia fine è sera.",
      boxes: {
        tessuto: ["Tessuto", "Super 130s biellese: più fine, più compatto, più serale."],
        vestibilita: ["Vestibilità", "Slim misurata: vicino al corpo senza stringere."],
        madeinitaly: ["Made in Italy", "Filiera corta e certificata, dalla pezza al capo finito."],
      },
      look: { enabled: true, image: "../assets/worn-suit-anthracite.jpg", caption: "Il look completo: abito antracite, camicia bianca, cintura in cuoio" },
    },
    "camicia-azzurra": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Regular. Collo semi-francese, polso arrotondato. Il modello indossa la 40.",
      care: "Lavatrice 40°, stiratura media. Non candeggiare.",
      bullets: ["Popeline di cotone doppio ritorto", "Collo semi-francese con stecche estraibili", "Bottoni in madreperla", "Cuciture inglesi a 8 punti/cm", "Confezionata in Toscana"],
      styleNote: "L’azzurro chiaro è la camicia da abito per definizione: blu, grigio, verde — va con tutto.",
      boxes: {
        tessuto: ["Tessuto", "Doppio ritorto egiziano: compatto, lucido, resta liscio."],
        vestibilita: ["Vestibilità", "Regular: comoda in spalla, pulita in vita."],
        madeinitaly: ["Made in Italy", "Cucita in Toscana, bottoni in vera madreperla."],
      },
      look: { enabled: true, image: "../assets/worn-shirt-blue.jpg", caption: "Il look completo: camicia azzurra, pantalone in lana, cintura in cuoio" },
    },
    "camicia-bianca": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Regular. Collo semi-francese. Il modello indossa la 40.",
      care: "Lavatrice 40°, stiratura media. Candeggio delicato ammesso.",
      bullets: ["Twill di cotone doppio ritorto", "Bianco ottico, non trasparente", "Bottoni in madreperla", "Cuciture inglesi a 8 punti/cm", "Confezionata in Toscana"],
      styleNote: "La bianca è il foglio bianco del guardaroba: cerimonia, colloquio, sera. Una non basta mai.",
      boxes: {
        tessuto: ["Tessuto", "Twill doppio ritorto: corposo il giusto, mai trasparente."],
        vestibilita: ["Vestibilità", "Regular: comoda in spalla, pulita in vita."],
        madeinitaly: ["Made in Italy", "Cucita in Toscana, bottoni in vera madreperla."],
      },
      look: { enabled: true, image: "../assets/worn-shirt-white.jpg", caption: "Il look completo: camicia bianca, pantalone antracite, cintura in cuoio" },
    },
    "camicia-in-lino": {
      sizeTools: true, styleSelect: true,
      fitSheet: "Vestibilità Soft. Collo alla francesina, manica leggermente ampia. Il modello indossa la 41.",
      care: "Lavatrice 30°, asciugatura naturale. Il lino si stropiccia: è il suo carattere.",
      bullets: ["Lino normanno 100%, 160 g/m²", "Tinto in capo: colore profondo e vivo", "Bottoni in corozo", "Manica arrotolabile con linguetta", "Confezionata in Toscana"],
      styleNote: "Il lino beige è l’estate elegante: sotto l’abito non strutturato, da solo con pantalone bianco.",
      boxes: {
        tessuto: ["Tessuto", "Lino normanno: si stropiccia con eleganza e regge gli anni."],
        vestibilita: ["Vestibilità", "Soft: rilassata ma mai sciatta."],
        madeinitaly: ["Made in Italy", "Filato europeo, confezione toscana."],
      },
      look: { enabled: true, image: "../assets/worn-shirt-linen.jpg", caption: "Il look completo: camicia in lino, pantalone in lino, cintura in cuoio" },
    },
    "girocollo-merino": {
      sizeTools: true, styleSelect: false,
      fitSheet: "Vestibilità Regular. Fondo e polsi a costina. Il modello indossa la M.",
      care: "Lavatrice a freddo programma lana, asciugatura in piano.",
      bullets: ["Merino extrafine 19,5 micron", "Filato anti-pilling, lavabile in lavatrice", "Maglia rasata 12 gauge", "Fondo e polsi a costina", "Maglieria di Toscana"],
      styleNote: "Il grigio medio in merino è il maglione da ufficio: sopra la camicia, sotto la giacca, non sbaglia mai.",
      boxes: {
        tessuto: ["Filato", "Merino extrafine: termoregola, respira, non pizzica."],
        vestibilita: ["Vestibilità", "Regular: pulita, pensata per stare sotto la giacca."],
        madeinitaly: ["Made in Italy", "Lavorato in Toscana da filato certificato."],
      },
      look: { enabled: true, image: "../assets/worn-knit-merino.jpg", caption: "Il look completo: girocollo merino, camicia bianca, pantalone in lana" },
    },
    "girocollo-cashmere": {
      sizeTools: true, styleSelect: false,
      fitSheet: "Vestibilità Regular. Girocollo bordato a mano. Il modello indossa la M.",
      care: "Lavaggio a mano a freddo, asciugatura in piano. Poco e con cura.",
      bullets: ["Cashmere 2 fili, fibra lunga pettinata", "Morbido dal primo giorno, con la cura giusta resta tale", "Maglia rasata 12 gauge", "Collo bordato a mano", "Maglieria di Toscana"],
      styleNote: "Il cashmere blu è il pezzo che dura vent’anni: con la camicia è lavoro, con la t-shirt è weekend.",
      boxes: {
        tessuto: ["Filato", "Cashmere 2 fili: caldo senza peso, fibra lunga pettinata."],
        vestibilita: ["Vestibilità", "Regular: pulita, mai abbondante."],
        madeinitaly: ["Made in Italy", "Filato e lavorato in Italia, filiera tracciata."],
      },
      look: { enabled: true, image: "../assets/worn-knit-cashmere.jpg", caption: "Il look completo: girocollo cashmere, pantalone in cotone, cintura in cuoio" },
    },
    "cravatta-seta-bordeaux": {
      sizeTools: false, styleSelect: false, fitSheet: null,
      care: "Solo lavaggio a secco. Snodala a fine giornata e arrotolala: la seta ringrazia.",
      bullets: ["Seta di Como 100%, twill 3 pieghe", "Annodata a mano, anima in lana", "Larghezza 8 cm, lunghezza 148 cm", "Fodera jacquard tono su tono", "Distretto serico comasco"],
      styleNote: "Il bordeaux è la cravatta che chiude il look: con abito blu e camicia azzurra è impeccabile, con il grigio è memorabile.",
      boxes: {
        tessuto: ["Tessuto", "Twill di seta comasca: mano piena, nodo che tiene."],
        vestibilita: ["Misure", "Larghezza 8 cm, lunghezza 148 cm. Taglia unica."],
        madeinitaly: ["Made in Italy", "Stampata e annodata a mano a Como."],
      },
      look: { enabled: true, image: "../assets/worn-tie-burgundy.jpg", caption: "Il look completo: cravatta bordeaux, camicia bianca, abito blu notte" },
    },
    "cintura-in-cuoio": {
      sizeTools: false, styleSelect: false, fitSheet: null,
      care: "Niente acqua, niente sole diretto. Ogni tanto un velo di crema neutra per cuoio.",
      bullets: ["Cuoio toscano pieno fiore", "Fodera in nabuk, fibbia anallergica", "Larghezza 3,5 cm", "Si accorcia dal lato fibbia", "Concia vegetale certificata"],
      styleNote: "Il cuoio marrone vive con blu, grigio e beige. Con l’abito scegli fibbia piccola e finish opaco: come questa.",
      boxes: {
        tessuto: ["Materiale", "Pieno fiore a concia vegetale: invecchia e migliora."],
        vestibilita: ["Misure", "Larghezza 3,5 cm. Regolabile dal lato fibbia."],
        madeinitaly: ["Made in Italy", "Tagliata e rifinita a mano in Toscana."],
      },
      look: { enabled: true, image: "../assets/worn-belt-brown.jpg", caption: "Il look completo: cintura in cuoio, pantalone grigio, camicia bianca" },
    },
  };
  const PDP_GENERIC = {
    sizeTools: true, styleSelect: true,
    fitSheet: "Vestibilità Regular. Il modello è alto 188 cm.",
    care: "Segui le indicazioni in etichetta.",
    bullets: ["Tessuti italiani selezionati", "Confezione artigianale", "Vestibilità misurata", "Dettagli curati", "Made in Italy"],
    styleNote: "Un capo Del Mare: misura, materia e durata.",
    boxes: {
      tessuto: ["Tessuto", "Fibra naturale italiana, filiera tracciata."],
      vestibilita: ["Vestibilità", "Taglio misurato milanese."],
      madeinitaly: ["Made in Italy", "Filiera corta e certificata."],
    },
    look: { enabled: true, image: "../assets/worn-suit-navy.jpg", caption: "Il look completo Del Mare" },
  };

  const hydratePdp = (card) => {
    const isDefault = card.dataset.fModello === "completi" && card.dataset.fColore === "blu" && card.dataset.fMateriale === "lana";
    const title = card.querySelector(".dm-product-card__title")?.textContent.trim() || PDP_DEFAULT.title;
    const micro = card.querySelector(".dm-product-card__micro")?.textContent.trim() || PDP_DEFAULT.micro;
    const priceHtml = card.querySelector(".dm-product-card__price")?.innerHTML.trim() || PDP_DEFAULT.priceHtml;
    const img = card.querySelector("img.is-product")?.getAttribute("src") || PDP_DEFAULT.img;
    const worn = card.querySelector("img.is-worn")?.getAttribute("src");
    const taglia = card.dataset.fTaglia || PDP_DEFAULT.taglia;
    const colore = card.dataset.fColore || PDP_DEFAULT.colore;
    const modello = card.dataset.fModello || "";

    const set = (sel, fn) => { const el = qs(sel); if (el) fn(el); };
    set("[data-pdp-title]", (el) => (el.textContent = title));
    set("[data-pdp-micro]", (el) => (el.textContent = micro));
    set("[data-pdp-price]", (el) => (el.innerHTML = priceHtml));
    set("[data-sticky-title]", (el) => (el.textContent = title));
    set("[data-sticky-price]", (el) => (el.textContent = priceHtml.replace(/<[^>]*>/g, "").trim().split(" ").slice(-2).join(" ")));
    set("[data-color-name]", (el) => (el.textContent = valueLabels.colore[colore] || colore));

    // Gallery: packshot, worn shot, then the macro of the actual cloth
    const main = qs("[data-gallery-main]");
    if (main) { main.src = img; main.alt = title; }
    const thumbs = qsa("[data-gallery-thumb]");
    // The filter key is a family ("lana" covers suiting and merino), so a product
    // can name its own cloth to get the right macro.
    const macro =
      FABRIC_MACRO[card.dataset.macro] ||
      FABRIC_MACRO[card.dataset.fMateriale] ||
      PDP_THUMB_EXTRAS[1];
    const sources = isDefault
      ? [PDP_DEFAULT.img, ...PDP_THUMB_EXTRAS]
      : [img, worn, macro].filter(Boolean);
    thumbs.forEach((t, i) => {
      const src = sources[i];
      t.hidden = !src;
      if (src) {
        t.dataset.src = src;
        const im = t.querySelector("img");
        if (im) im.src = src;
      }
      t.classList.toggle("is-active", i === 0);
    });

    // Sizes from the card's taglia list (optional data-f-stock="ok,low,out,…" aligned per size)
    const sizeWrap = qs("[data-size-avail]");
    if (sizeWrap) {
      const sizes = taglia === "u" ? ["Unica"] : taglia.split(",").filter(Boolean);
      const stocks = (card.dataset.fStock || "").split(",").filter(Boolean);
      const stockLabel = { ok: "Disponibile", low: "Ultimi pezzi", out: "Esaurita" };
      let firstOk = -1;
      const btns = sizes.map((s, i) => {
        const st = stocks[i] || "ok";
        if (firstOk === -1 && st !== "out") firstOk = i;
        return { s, st };
      });
      sizeWrap.innerHTML = btns
        .map(
          ({ s, st }, i) =>
            `<button type="button" class="${i === firstOk ? "is-selected" : ""}${st === "low" ? " is-low" : ""}${st === "out" ? " is-soldout is-notify" : ""}" data-size="${s === "Unica" ? "u" : s}" data-stock="${st}">${s}<small>${st === "out" ? "Avvisami" : stockLabel[st]}</small></button>`
        )
        .join("");
      const selBtn = sizeWrap.querySelector("button.is-selected") || sizeWrap.querySelector("button");
      if (selBtn) updateSizeStatus(selBtn);
    }

    // Color thumbs only make sense for tailoring variants
    const thumbsWrap = qs("[data-color-thumbs]");
    if (thumbsWrap) thumbsWrap.hidden = !isDefault;

    const page = document.getElementById("product");
    const handle = title.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    const spec = PDP_CATALOG[handle] || PDP_GENERIC;

    // Toggle + fill per-product modules
    const toggle = (sel, show) => qsa(sel).forEach((el) => (el.hidden = !show));
    toggle("[data-pdp-assistant]", spec.sizeTools);
    toggle("[data-pdp-style-row]", spec.styleSelect);
    toggle("[data-pdp-style-select]", spec.styleSelect);
    const fitSheet = qs("[data-pdp-fit-sheet]");
    if (fitSheet) {
      fitSheet.hidden = !spec.fitSheet;
      if (spec.fitSheet) fitSheet.textContent = spec.fitSheet;
    }
    set("[data-pdp-care]", (el) => (el.textContent = spec.care));
    const bulletsEl = qs("[data-pdp-bullets]");
    if (bulletsEl) bulletsEl.innerHTML = spec.bullets.map((b) => `<li>${b}</li>`).join("");
    set("[data-pdp-style-note]", (el) => (el.textContent = spec.styleNote));
    qsa("[data-pdp-box]").forEach((box) => {
      const cfg = spec.boxes[box.dataset.pdpBox];
      if (!cfg) { box.hidden = true; return; }
      box.hidden = false;
      const h = box.querySelector("h3");
      const p = box.querySelector("p");
      if (h) h.textContent = cfg[0];
      if (p) p.textContent = cfg[1];
    });
    const lookSection = qs("[data-pdp-look]");
    if (lookSection) {
      lookSection.hidden = !spec.look.enabled;
      if (spec.look.enabled) {
        const li = qs("[data-look-image]");
        if (li) { li.src = spec.look.image; li.alt = spec.look.caption; }
        set("[data-look-caption]", (el) => (el.textContent = spec.look.caption));
      }
    }

    if (page) {
      page.dataset.productTitle = title;
      page.dataset.productImage = img;
      page.dataset.productHandle = handle;
    }

    // Keep cart data in sync with the hydrated product
    const priceNum = (priceHtml.match(/€\s*([\d.]+)(?!.*€)/) || [])[1] || "490";
    document.body.dataset.productTitle = title;
    document.body.dataset.productImage = img;
    document.body.dataset.productHandle = handle;
    document.body.dataset.dmPrice = priceNum;
    if (document.body.dataset.customerType !== "b2b") {
      qsa("[data-atc-label]").forEach((el) => {
        el.textContent = el.closest("[data-sticky-atc]") ? "Aggiungi" : `Aggiungi al carrello — € ${priceNum}`;
      });
    }
  };

  /* Nav-driven prefilter: [data-nav-filter="group:value"] */
  const setCollectionTitle = (spec) => {
    const title = qs("[data-collection-title]");
    if (!title) return;
    if (!spec) { title.textContent = title.dataset.default || title.textContent; return; }
    const [group, value] = spec.split(":");
    title.textContent = valueLabels[group]?.[value] || title.dataset.default || title.textContent;
  };
  const prefilter = (spec) => {
    Object.keys(filterState).forEach((g) => (filterState[g] = []));
    if (spec) {
      const [group, value] = spec.split(":");
      if (filterState[group]) filterState[group] = [value];
    }
    qsa("[data-filter-opt]").forEach((o) => {
      const on = spec && o.dataset.group === spec.split(":")[0] && o.dataset.value === spec.split(":")[1];
      o.classList.toggle("is-selected", !!on);
    });
    setCollectionTitle(spec);
    applyFilters();
  };
  document.addEventListener("click", (e) => {
    const nav = e.target.closest("[data-nav-filter]");
    if (!nav) return;
    const href = nav.getAttribute("href") || nav.getAttribute("data-nav") || "";
    if (href.includes("collection") || document.querySelector(".preview-page")) {
      if (href.startsWith("#")) e.preventDefault();
      showPage("collection");
      prefilter(nav.getAttribute("data-nav-filter") || null);
      window.scrollTo(0, 0);
    }
  });

  // Build desktop panels
  if (grid) {
    qsa("[data-filter-panel]").forEach((panel) => buildPanel(panel.dataset.filterPanel, panel));
    // Build mobile drawer
    const drawerBody = qs("[data-filter-drawer-body]");
    if (drawerBody) {
      drawerBody.innerHTML = ["modello", "colore", "materiale", "taglia", "novita"]
        .map(
          (group) => `<details class="dm-filter-drawer__group" ${group === "modello" ? "open" : ""}>
            <summary>${groupLabels[group]}</summary>
            <div class="dm-filter-drawer__opts" data-drawer-group="${group}"></div>
          </details>`
        )
        .join("");
      qsa("[data-drawer-group]").forEach((wrap) => buildPanel(wrap.dataset.drawerGroup, wrap));
    }

    // Desktop dropdown open/close
    qsa("[data-filter-group]").forEach((group) => {
      const btn = group.querySelector("[data-filter-group-btn]");
      btn?.addEventListener("click", (e) => {
        e.stopPropagation();
        const wasOpen = group.classList.contains("is-open");
        qsa("[data-filter-group]").forEach((g) => {
          g.classList.remove("is-open");
          g.querySelector("[data-filter-group-btn]")?.setAttribute("aria-expanded", "false");
        });
        if (!wasOpen) {
          group.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-filter-group]")) {
        qsa("[data-filter-group]").forEach((g) => g.classList.remove("is-open"));
      }
    });

    // Option clicks (delegated, works for both desktop panels + drawer)
    document.addEventListener("click", (e) => {
      const opt = e.target.closest("[data-filter-opt]");
      if (opt) {
        toggleFilter(opt.dataset.group, opt.dataset.value);
        return;
      }
      const chip = e.target.closest("[data-chip]");
      if (chip) {
        toggleFilter(chip.dataset.group, chip.dataset.value, false);
        return;
      }
      if (e.target.closest("[data-clear-filters]")) clearFilters();
    });

    // Mobile drawer open/close
    qs("[data-filter-open]")?.addEventListener("click", () => {
      qs("[data-filter-drawer]")?.classList.add("is-open");
    });
    qsa("[data-filter-close]").forEach((el) => el.addEventListener("click", closeFilterDrawer));

    // Sort
    qs("[data-sort]")?.addEventListener("change", (e) => {
      const mode = e.target.value;
      const sorted = [...cards];
      if (mode === "price-asc") sorted.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
      else if (mode === "price-desc") sorted.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
      else if (mode === "new") sorted.sort((a, b) => Number(b.dataset.new || 0) - Number(a.dataset.new || 0));
      sorted.forEach((c) => grid.appendChild(c));
    });

    applyFilters();
  }

  /* ---------- Recently viewed (initial render) ---------- */
  renderRecentlyViewed();

  /* ---------- Login tabs ---------- */
  qsa("[data-login-tab]").forEach((tab) => {
    tab.addEventListener("click", () => {
      const scope = tab.closest(".container") || document;
      qsa("[data-login-tab]", scope).forEach((t) => t.classList.remove("is-active"));
      tab.classList.add("is-active");
      const mode = tab.dataset.loginTab;
      qsa("[data-login-panel]", scope).forEach((p) => {
        p.hidden = p.dataset.loginPanel !== mode;
      });
    });
  });

  /* ---------- Search ---------- */
  qsa("[data-open-search]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (!searchPanel) return;
      const open = searchPanel.hidden || !searchPanel.classList.contains("is-open");
      searchPanel.classList.toggle("is-open", open);
      searchPanel.hidden = !open;
      if (open) {
        renderSearch(searchInput?.value || "");
        searchPanel.querySelector("input")?.focus();
      }
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeSearch();
      closeCart();
      closeMega();
      closeFilterDrawer();
      sizeModal?.classList.remove("is-open");
    }
  });

  /* ---------- B2B toggle ---------- */
  qsa("[data-toggle-b2b]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const next = document.body.dataset.customerType !== "b2b";
      document.body.dataset.customerType = next ? "b2b" : "b2c";
      syncB2BUI();
      btn.textContent = next ? "Esci da B2B" : "Simula login B2B";
    });
  });

  /* ---------- B2B dashboard ---------- */
  const b2bLogin = (goToDash = true) => {
    document.body.dataset.customerType = "b2b";
    syncB2BUI();
    if (goToDash) showPage("b2b-dash");
  };

  qs("[data-b2b-login]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    b2bLogin();
    showToast("Bentornato, Grand Hotel Adriatico");
  });

  qsa("[data-b2b-enter]").forEach((el) =>
    el.addEventListener("click", () => b2bLogin(false))
  );

  qs("[data-b2b-logout]")?.addEventListener("click", () => {
    document.body.dataset.customerType = "b2c";
    syncB2BUI();
    showToast("Sei uscito dall’area Business");
  });

  // Panel navigation
  qsa("[data-dash-nav]").forEach((btn) => {
    btn.addEventListener("click", () => {
      qsa("[data-dash-nav]").forEach((b) => b.classList.toggle("is-active", b === btn));
      qsa("[data-dash-panel]").forEach((p) => (p.hidden = p.dataset.dashPanel !== btn.dataset.dashNav));
    });
  });

  // Size-matrix quick reorder with live totals from the reserved price list
  const updateMatrix = () => {
    let grandQty = 0;
    let grandSum = 0;
    qsa("[data-matrix]").forEach((m) => {
      const price = Number(m.dataset.price) || 0;
      const qty = qsa("[data-matrix-qty]", m).reduce((acc, i) => acc + (parseInt(i.value, 10) || 0), 0);
      grandQty += qty;
      grandSum += qty * price;
      const total = qs("[data-matrix-total]", m);
      if (total) {
        total.innerHTML =
          qty > 0
            ? `<strong>${qty} cap${qty === 1 ? "o" : "i"} · € ${(qty * price).toLocaleString("it-IT")}</strong>`
            : "0 capi";
      }
    });
    const grand = qs("[data-matrix-grand]");
    if (grand) grand.textContent = `${grandQty} cap${grandQty === 1 ? "o" : "i"} · € ${grandSum.toLocaleString("it-IT")}`;
    return { grandQty, grandSum };
  };
  qsa("[data-matrix-qty]").forEach((i) => i.addEventListener("input", updateMatrix));

  qs("[data-matrix-submit]")?.addEventListener("click", () => {
    const { grandQty, grandSum } = updateMatrix();
    if (!grandQty) {
      showToast("Indica almeno una quantità");
      return;
    }
    const lines = [];
    qsa("[data-matrix]").forEach((m) => {
      const title = qs(".dm-matrix__head strong", m)?.textContent?.trim();
      const price = Number(m.dataset.price) || 0;
      qsa("[data-matrix-qty]", m).forEach((input) => {
        const qty = parseInt(input.value, 10) || 0;
        if (!qty) return;
        const size = qs("label", input.closest(".dm-matrix__cell"))?.textContent?.trim();
        lines.push(`${title} · taglia ${size}: ${qty} capi (€ ${price * qty})`);
      });
    });
    const payload = { lines, grandQty, grandSum };
    if (!IS_PREVIEW) {
      try {
        sessionStorage.setItem("dm_b2b_matrix", JSON.stringify(payload));
      } catch (_) {}
      window.location.href = "/pages/b2b-quote?from=matrix";
      return;
    }
    qsa("[data-matrix-qty]").forEach((i) => (i.value = ""));
    updateMatrix();
    showToast(`Richiesta inviata: ${grandQty} capi. Preventivo entro 1 giorno lavorativo`);
  });

  // Staff wardrobe roster
  qs("[data-staff-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const [name, dept, suit, shirt] = qsa("input, select", form).map((el) => el.value.trim());
    if (!name) return;
    const tbody = qs("[data-staff-table] tbody");
    if (tbody) {
      const tr = document.createElement("tr");
      const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;");
      tr.innerHTML = `<td>${esc(name)}</td><td>${esc(dept)}</td><td>${esc(suit)}</td><td>${esc(shirt)}</td><td><button type="button" class="btn btn--outline dm-btn-kit" data-staff-kit="${esc(name)}">Ordina kit</button></td>`;
      tbody.appendChild(tr);
    }
    form.reset();
    showToast(`${name} aggiunto al guardaroba ${dept}`);
  });

  document.addEventListener("click", (e) => {
    const kit = e.target.closest("[data-staff-kit]");
    if (kit) {
      showToast(`Kit divisa per ${kit.dataset.staffKit} aggiunto al preventivo`);
      return;
    }
    const reorder = e.target.closest("[data-reorder]");
    if (reorder) {
      showToast(`Riordino di ${reorder.dataset.reorder} inviato: confermiamo entro 1 giorno`);
    }
  });

  /* ---------- Live search suggestions ---------- */
  const SEARCH_CATALOG = [
    { title: "Abito blu notte", price: 490, img: "../assets/product-suit-navy.jpg", tags: "abito completo blu navy suit" },
    { title: "Abito grigio medio", price: 590, img: "../assets/product-suit-grey.jpg", tags: "abito completo grigio grey suit" },
    { title: "Abito verde bottiglia", price: 620, img: "../assets/product-suit-green.jpg", tags: "abito verde green suit bottiglia" },
    { title: "Abito antracite", price: 620, img: "../assets/product-suit-anthracite.jpg", tags: "abito antracite charcoal suit scuro" },
    { title: "Camicia azzurra", price: 120, img: "../assets/product-shirt-blue.jpg", tags: "camicia azzurra cotone shirt blue" },
    { title: "Camicia bianca", price: 120, img: "../assets/product-shirt-white.jpg", tags: "camicia bianca popeline shirt white" },
    { title: "Camicia in lino", price: 140, img: "../assets/product-shirt-linen.jpg", tags: "camicia lino linen shirt beige" },
    { title: "Girocollo merino", price: 160, img: "../assets/product-knit-charcoal.jpg", tags: "maglia merino girocollo knit crewneck grigio" },
    { title: "Girocollo cashmere", price: 240, img: "../assets/product-knit-navy.jpg", tags: "cashmere girocollo maglia knit navy blu" },
    { title: "Cravatta seta bordeaux", price: 75, img: "../assets/product-tie-burgundy.jpg", tags: "cravatta seta tie bordeaux" },
    { title: "Cintura in cuoio", price: 95, img: "../assets/product-belt-brown.jpg", tags: "cintura cuoio pelle belt" },
  ];
  const searchInput = qs("[data-search-input]");
  const searchResults = qs("[data-search-results]");
  const renderSearch = (query) => {
    if (!searchResults) return;
    const q = query.trim().toLowerCase();
    const hits = q
      ? SEARCH_CATALOG.filter((p) => `${p.title} ${p.tags}`.toLowerCase().includes(q))
      : SEARCH_CATALOG.slice(0, 4);
    if (q && !hits.length) {
      searchResults.innerHTML = `<p class="dm-search-empty">Nessun risultato per “${query}”. Prova “abito”, “camicia” o “cashmere”.</p>`;
      return;
    }
    searchResults.innerHTML = `
      <div class="dm-search-results__label">${q ? `${hits.length} risultat${hits.length === 1 ? "o" : "i"}` : "Più cercati"}</div>
      <div class="dm-search-results">${hits
        .map(
          (p) => `<a class="dm-search-hit" href="#product" data-go>
            <img src="${p.img}" alt="">
            <div><div class="dm-search-hit__title">${p.title}</div><div class="dm-search-hit__price">€ ${p.price}</div></div>
          </a>`
        )
        .join("")}</div>`;
  };
  searchInput?.addEventListener("input", () => renderSearch(searchInput.value));

  /* ---------- Checkout page ---------- */
  let couponDiscount = 0;
  const renderCheckout = () => {
    const linesWrap = qs("[data-checkout-lines]");
    if (!linesWrap) return;
    linesWrap.innerHTML = cartItems.length
      ? cartItems
          .map(
            (item) => `<div class="dm-cart-line">
              <img src="${item.img}" alt="">
              <div><div>${item.title}${(item.qty || 1) > 1 ? ` <span class="muted">× ${item.qty}</span>` : ""}</div><div class="muted">€ ${Number(item.price) * (item.qty || 1)}</div></div>
            </div>`
          )
          .join("")
      : `<p class="muted">Il carrello è vuoto. <a href="#collection" data-go>Vai alla collezione</a></p>`;
    const subtotal = cartTotal();
    const shipping = subtotal === 0 ? 0 : subtotal >= FREE_SHIP ? 0 : 6;
    const total = Math.max(0, subtotal - couponDiscount + shipping);
    const set = (sel, val) => { const el = qs(sel); if (el) el.textContent = val; };
    set("[data-sum-subtotal]", `€ ${subtotal}`);
    set("[data-sum-shipping]", subtotal === 0 ? "—" : shipping === 0 ? "Gratuita" : `€ ${shipping.toFixed(2).replace(".", ",")}`);
    set("[data-sum-total]", `€ ${total % 1 ? total.toFixed(2).replace(".", ",") : total}`);
    set("[data-pay-total]", `€ ${total % 1 ? total.toFixed(2).replace(".", ",") : total}`);
    set("[data-sum-discount]", `−€ ${couponDiscount}`);
    const discRow = qs("[data-sum-discount-row]");
    if (discRow) discRow.hidden = couponDiscount === 0;
  };

  qs("[data-coupon-apply]")?.addEventListener("click", () => {
    const input = qs("[data-coupon-input]");
    const code = (input?.value || "").trim().toUpperCase();
    const btn = qs("[data-coupon-apply]");
    if (code === "BENVENUTO10") {
      couponDiscount = Math.round(cartTotal() * 0.1);
      if (btn) btn.textContent = "Applicato";
      if (input) input.disabled = true;
    } else {
      couponDiscount = 0;
      if (btn) btn.textContent = "Non valido";
      setTimeout(() => { if (btn) btn.textContent = "Applica"; }, 1500);
    }
    renderCheckout();
  });

  const completeOrder = (method) => {
    qs("[data-checkout-form]").hidden = true;
    const success = qs("[data-checkout-success]");
    if (success) {
      success.hidden = false;
      const num = qs("[data-order-number]");
      if (num) num.textContent = `DM-${Math.floor(1000 + Math.random() * 9000)}`;
    }
    cartItems.length = 0;
    cartCount = 0;
    couponDiscount = 0;
    renderCart();
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (method) {
      const h = success?.querySelector("h2");
      if (h) h.textContent = `Ordine confermato con ${method}`;
    }
  };

  qs("[data-pay-form]")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const btn = qs("[data-pay-button]");
    if (btn) btn.textContent = "Elaborazione…";
    setTimeout(() => completeOrder(), 900);
  });

  qsa("[data-express-pay]").forEach((btn) =>
    btn.addEventListener("click", () => {
      btn.textContent = "…";
      setTimeout(() => completeOrder(btn.dataset.expressPay), 700);
    })
  );

  // Cart drawer express buttons → checkout page
  qsa("[data-express]").forEach((btn) =>
    btn.addEventListener("click", () => {
      closeCart();
      showPage("checkout");
    })
  );
  if (IS_PREVIEW) {
    qsa("[data-lang]").forEach((a) => {
      a.addEventListener("click", (e) => {
        e.preventDefault();
        qsa("[data-lang]").forEach((x) => x.classList.remove("is-active"));
        a.classList.add("is-active");
      });
    });
  }

  const igCaption = (post) => {
    const raw = post.caption || post.text || "";
    const first = raw.replace(/\s+/g, " ").trim().split(/[.!?\n]/)[0];
    return first.slice(0, 90);
  };

  const renderIgPosts = (grid, posts, handle) => {
    if (!grid || !posts.length) return;
    grid.classList.toggle("dm-ig-grid--4", posts.length > 3);
    grid.innerHTML = posts
      .map((post) => {
        const href = post.permalink || post.url || post.link || `https://www.instagram.com/${handle}/`;
        const img =
          post.sizes?.medium?.mediaUrl ||
          post.sizes?.small?.mediaUrl ||
          post.mediaUrl ||
          post.media_url ||
          post.display_url ||
          post.image ||
          post.thumbnail;
        const title = igCaption(post);
        if (!img) return "";
        return `<a class="dm-ig-card" href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">
          <span class="dm-ig-card__media">
            <img decoding="async" src="${escapeHtml(img)}" alt="${escapeHtml(title || handle)}" loading="lazy" width="900" height="900">
          </span>
          ${title ? `<span class="dm-ig-card__title">${escapeHtml(title)}</span>` : ""}
        </a>`;
      })
      .join("");
  };

  const initInstagramFeed = () => {
    const root = qs("[data-ig-root]");
    const grid = qs("[data-ig-grid]");
    const feedUrl = root?.dataset.igFeed;
    if (!root || !grid || !feedUrl) return;
    const count = Number(root.dataset.igCount) || 4;
    const handle = root.dataset.igHandle || "delmare.1911";
    const cacheKey = `dm_ig_${feedUrl}`;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || "null");
      if (cached?.posts?.length && Date.now() - cached.at < 15 * 60 * 1000) {
        renderIgPosts(grid, cached.posts.slice(0, count), handle);
        return;
      }
    } catch (e) {
      /* ignore */
    }
    fetch(feedUrl, { credentials: "omit" })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((data) => {
        const posts = data.posts || data.items || data.data || [];
        if (!posts.length) return;
        sessionStorage.setItem(cacheKey, JSON.stringify({ at: Date.now(), posts }));
        renderIgPosts(grid, posts.slice(0, count), handle);
      })
      .catch(() => {});
  };

  syncB2BUI();
  initAddressManager();
  initInstagramFeed();
  if (IS_PREVIEW) {
    renderCart();
  } else {
    initShopifyProductForm();
    if (document.body.dataset.productHandle) {
      recordRecentlyViewed();
      renderRecentlyViewed();
    }
  }
})();
